<template>
  <div class="w-full">
    <div class="w-full px-6 pt-10">
      <HomeMainFilter
        v-model:search="search"
        v-model:selectedFilter="selectedFilter"
        @onApplyFilters="handleApplyFilters"
        @onSearchCourse="searchCourse"
        @onResetFilters="handleClickResetFilter"
        :hideSortProgress="true"
        :hideEnrolledProgress="true"
        :hideAvailableCourse="true"
      />
    </div>
    <div class="py-10 w-full px-6">
      <div
        class="mx-auto mt-6 md:h-[800px] lg:h-[2000px] xl:h-auto overflow-y-scroll"
      >
        <div role="list" class="flex flex-col">
          <template v-if="loading.initialData">
            <ul role="list" class="flex flex-col">
              <li
                v-for="i in 6"
                :key="i"
                class="flex flex-col rounded-lg bg-white"
              >
                <SkeletonCourseCard />
              </li>
            </ul>
          </template>
          <div v-else-if="courses.length === 0 && !loading.nextPage"  class="text-center">
            <div class="block pt-5">No course(s) found.</div>
          </div>
          <div v-for="course in courses" :key="course" v-else>
            <ScormCourseCard :course="course"></ScormCourseCard>
          </div>
          <div class="text-center mt-5">
            <button
              v-if="!loading.nextPage && !isLastPage && courses.length > 0"
              type="button"
              @click="viewMore()"
            >
              View More Courses
            </button>
          </div>
          <div class="text-center" v-if="loading.nextPage">
            <loading-state />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, inject, computed } from "vue";
import ScormCourseCard from "@/components/scorm/ScormCourseCard.vue";
import SkeletonCourseCard from "@/components/loaders/SkeletonCourseCard.vue";
import LoadingState from "@/components/partials/LoadingState.vue";
import HomeMainFilter from "../home/filters/HomeMainFilter.vue";
import { useRouter } from "vue-router";

const courses = ref([]);

const axios = inject("axios");
const router = useRouter();
const search = ref();
const selectedFilter = ref({
  sort: null,
  filter: null,
  available_course: false,
  enrolled_course: true,
  course_category: [],
});
const page = ref(1);
const isLastPage = ref(false);
const loading = ref({
  initialData: true,
  nextPage: true,
});

const paramsFilter = computed(() => {
  return {
    search: search.value,
    page: page.value,
    ...selectedFilter.value,
  };
});

const viewMore = () => {
  loading.value.nextPage = true;
  page.value += 1;

  getScormCourses();
};

const handleApplyFilters = () => {
  loading.value.nextPage = true;
  page.value = 1;
  courses.value = [];
  getScormCourses();
};

const getScormCourses = async () => {
  isLastPage.value = false;
  await axios
    .get(`api/v3/scorm/courses`, { params: paramsFilter.value })
    .then(({ data }) => {
      courses.value = [...courses.value, ...data.data.items];

      if (data.data.items.length === 0 || data.data.meta.total_items <= 10) {
        isLastPage.value = true;
      }
      loading.value.initialData = false;
      loading.value.nextPage = false;
    });
};

const searchCourse = () => {
  router.push({
    name: "search",
    query: {
      search: search.value,
    },
  });
};

const handleClickResetFilter = () => {
  handleResetFilter();
  loading.value.nextPage = true;
  page.value = 1;
  courses.value = [];
  getScormCourses();
};

const handleResetFilter = () => {
  selectedFilter.value = {
    sort: null,
    filter: null,
    available_course: false,
    enrolled_course: true,
    course_category: [],
  };
};

onMounted(async () => {
  loading.value.initialData = true;
  await getScormCourses();
});
</script>
